module.exports = __webpack_public_path__ + "static/media/totalInst.6d9872b7.png";